<template>
    <div>
        <page-header title="لیست کاربران" create-url="/customers/create"></page-header>

        <search-filter :filters="filters" @search="search"></search-filter>

        <table-with-pagination v-if="customers"
                               :items="customers"
                               :headers="headers"
                               :default-page="parseInt($route.query.page ?? '1')"
                               @fetchPage="getCustomers"
                               @delete="deleteCustomer"
                               @statusChanged="statusChanged"
                               :actions="actions"
        ></table-with-pagination>
    </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import TableWithPagination from "@/components/General/TableWithPagination";
import SearchFilter from "@/components/General/SearchFilter.vue";

export default {
    name: "CustomersList",

    components: {SearchFilter, TableWithPagination, PageHeader},

    data() {
        return {
            headers: [
                {text: 'شناسه', value: 'id', align: 'center'},
                {text: 'نام', value: 'name', align: 'center'},
                {text: 'شماره موبایل', value: 'phone_number', align: 'center'},
                {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
                {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
                {text: 'عملیات', value: 'actions', align: 'center'},
            ],

            customers: null,

            actions: [
                {
                    icon: 'mdi-pencil',
                    color: 'warning',
                    route_name: 'update-customer',
                    route_param: 'id'
                },
                {
                    icon: 'mdi-delete',
                    color: 'error',
                    emit: 'delete',
                    identifier: 'id',
                    delete_confirm: true,
                }
            ],

            filters: [
                {
                    type: 'text',
                    name: 'name',
                    label: 'نام',
                },
                {
                    type: 'text',
                    name: 'phone_number',
                    label: 'شماره',
                },
                // {
                //     type: 'select',
                //     name: 'status',
                //     label: 'وضعیت',
                //     select_text: 'text',
                //     select_value: 'value',
                //     select_items: [
                //         {text: 'فعال', value: '1'},
                //         {text: 'غیر فعال', value: '0'},
                //     ],
                // },
            ],
            searchValues: '',
        }
    },

    mounted() {
        this.getCustomers(parseInt(this.$route.query.page ?? "1"))
    },

    methods: {
        search(values) {
            this.$store.dispatch("objectParametersToString", values).then((result) => {
                this.searchValues = result
                this.getCustomers()
            })
        },

        getCustomers(page = 1) {
            this.$store.dispatch("getPaginatedCustomers", page + this.searchValues)
                .then((res) => {
                    this.customers = res.data
                })
        },

        deleteCustomer(slug) {
            this.$store.dispatch("deleteCustomer", slug)
                .then(() => {
                    this.getCustomers(this.customers.pagination.current_page)
                })
        },

        statusChanged(item) {
            this.$store.dispatch("toggleCustomerStatus", item.id)
                .then(() => {
                    this.getCustomers(this.customers.pagination.current_page)
                })
        }
    }
}
</script>

<style scoped>

</style>